import { type FC } from 'react';
import cn from 'classnames';
import dibsCss from 'dibs-css';
import { Link } from 'dibs-elements/exports/Link.tsx';
import { FormattedMessage } from 'dibs-react-intl';

import styles from './PdpSharedMediaCountPill.module.css';

export const PdpSharedMediaCountPill: FC<{
    photoCount: number;
    hasVideo: boolean;
    onClick?: () => void;
    className?: string;
    dataTn: string;
    size?: 'desktop' | 'mobile';
}> = ({ photoCount, hasVideo, onClick, className, dataTn, size = 'desktop' }) => {
    if (photoCount === 0 && !hasVideo) {
        return null;
    }

    const classNames = cn(
        styles.pill,
        size === 'mobile' ? styles.pillMobile : styles.pillDesktop,
        dibsCss.inlineFlex,
        dibsCss.itemsCenter,
        dibsCss.justifyCenter,
        dibsCss.m0,
        dibsCss.whitespaceNowrap,
        dibsCss.sassyBoxShadowDarker,
        onClick ? dibsCss.cursorPointer : dibsCss.cursorDefault,
        dibsCss.absolute,
        dibsCss.bottomXsmall,
        size === 'mobile' ? dibsCss.leftSmall : dibsCss.leftXsmall,
        dibsCss.zBump,
        dibsCss.sassyFontBodySmallHeavy,
        dibsCss.roundedFull,
        className
    );

    const content = (
        <>
            {photoCount > 0 && (
                <FormattedMessage
                    id="abf.PdpSharedMediaCountPill.photos"
                    defaultMessage="{count, plural, one {# Photo} other {# Photos}}"
                    values={{ count: photoCount }}
                />
            )}
            {photoCount > 0 && hasVideo && ', '}
            {hasVideo && (
                <FormattedMessage
                    id="abf.PdpSharedMediaCountPill.videos"
                    defaultMessage="1 Video"
                />
            )}
        </>
    );

    if (onClick) {
        return (
            <Link className={classNames} onClick={onClick} dataTn={dataTn}>
                {content}
            </Link>
        );
    }

    return (
        <div className={classNames} data-tn={dataTn}>
            {content}
        </div>
    );
};
